import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";

const FAQsQuestions = ({ faqData }) => {
  return (
    <>
      <div className="container  py-4">
        <h4 className="pb-2 text-capitalize  color-black text-center text-lg-start fs-4 fw-700">
          Frequently Asked Questions
        </h4>
        <div className="mb-5 ">
  {faqData.map((faq, index) => (
    <Accordion
      sx={{
        marginBottom: 1,
        boxShadow: "unset",
        border: 0,
        "&::before": {
          height: 0,
        },
      }}
      key={index}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon  />}  
        aria-controls={`panel${index}-content`}
        id={`panel${index}-header`}
        sx={{ 
          backgroundColor: "#efefef", 
          borderRadius: 2
        }}
      >
        <h6 style={{fontSize : 16}} className=" mb-0 py-2 ">{faq.question}</h6>
      </AccordionSummary>
      <AccordionDetails>
        <p style={{ fontSize: 13 }} className="py-2 ">
          {faq.answer}
        </p>
      </AccordionDetails>
    </Accordion>
  ))}
</div>

      </div>


      
    </>
  );
};

export default FAQsQuestions;
